import { useDeleteBinder, useRegenerateBinderToken, useUpdateBinder } from '@/hooks/binders/useBinders'
import type { Binder, BinderLayout } from '@/types'

/** Settings / delete / share-token handlers for a loaded binder, with `binder.id` already bound in. */
export function useBinderSettingsActions(binder: Binder | undefined) {
  const updateBinder = useUpdateBinder()
  const deleteBinder = useDeleteBinder()
  const regenerateToken = useRegenerateBinderToken()

  return {
    saveSettings: (
      updates: { name?: string; description?: string; layout?: BinderLayout; coverColor?: string },
      opts?: { onSuccess?: () => void },
    ) => {
      if (!binder) return
      updateBinder.mutate({ id: binder.id, data: updates }, { onSuccess: opts?.onSuccess })
    },
    deleteBinder: (opts?: { onSuccess?: () => void }) => {
      if (!binder) return
      deleteBinder.mutate(binder.id, { onSuccess: opts?.onSuccess })
    },
    regenerateToken: () => {
      if (!binder) return Promise.resolve()
      return regenerateToken.mutateAsync(binder.id)
    },
    isRegenerating: regenerateToken.isPending,
    isSaving: updateBinder.isPending,
    isDeleting: deleteBinder.isPending,
    saveError: updateBinder.error?.message,
  }
}
